import axios from "axios";
import WooCommerceRestApi from "@woocommerce/woocommerce-rest-api";
import wooCountries from './countries.json';
import statesData from './states.json';
export { extractUniqueAttributes } from "./product";
export { normalizeCouponData } from "./coupons";

const getWooClient = (version ='wc/v3') => {
  return new WooCommerceRestApi({
    url: process.env.GATSBY_WORDPRESS_URL,
    consumerKey: process.env.GATSBY_WC_CONSUMER_KEY,
    consumerSecret: process.env.GATSBY_WC_CONSUMER_SECRET,
    version,
    queryStringAuth: true,
  })
}

const formatPrice = (amount) => {

  if(String(amount).match(/£|\$/g)?.length == 1){
    return amount
  }else{
    let pounds = Intl.NumberFormat('en-GB', {
      style: 'currency',
      currency: 'GBP',
    });

    return pounds.format(amount);
  }
}

function formatDateTime(dateString) {
  const date = new Date(dateString);
  return `${date.getFullYear()} ${Intl.DateTimeFormat('en-UK', { month: 'short' }).format(date)}, ${date.getDate()} ${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}:${String(date.getSeconds()).padStart(2, '0')}`;
}

const getCountries = () => {
  return wooCountries;
}

const getStates = (countryCode) => {
  if (!countryCode) return [];
  return statesData[countryCode.toUpperCase()] || [];
}

const submitForm = async ({formId, payload}) => {
  try {
    let config = {
      method: 'post',
      maxBodyLength: Infinity,
      url: `${process.env.GATSBY_WORDPRESS_URL}/wp-json/gf/v2/forms/${formId}/submissions`,
      headers: { 
          'Content-Type': 'application/json', 
          'Authorization': `Basic ${process.env.GATSBY_WP_GFORMS_KEY}`
      },
      data : payload
    };

    const response = await axios.request(config)

    return {
      success: true,
      data: response.data,
      status: response.status
    }
    
  } catch (error) {

    // Check if this is a validation error (400 with validation_messages)
    if (error.response?.status === 400 && error.response?.data?.validation_messages) {
    
      const validationMessages = error.response.data.validation_messages;
      const firstErrorMessage = Object.values(validationMessages)[0] || "Form validation failed";
      
      return {
        success: false,
        isValidationError: true,
        validationErrors: validationMessages,
        errorMessage: firstErrorMessage,
        data: error.response.data
      };
    }

    return {
      success: false,
      error: {
        message: error.message,
        code: error.response?.status,
        details: error.response?.data
      }
    }
  }
}

// Decode basic HTML entities in strings coming from CMS (e.g., &amp; -> &)
const decodeEntities = (str) => {
  if (typeof str !== 'string') return str;
  const textarea = typeof document !== 'undefined' ? document.createElement('textarea') : null;
  if (textarea) {
    textarea.innerHTML = str;
    return textarea.value;
  }
  // Fallback for non-DOM environments (SSR): minimal replacements
  return str
    .replace(/&amp;/g, '&')
    .replace(/&lt;/g, '<')
    .replace(/&gt;/g, '>')
    .replace(/&quot;/g, '"')
    .replace(/&#39;/g, "'");
}

const cn = (...args) => {
  return args.filter(item => !!item).join(' ');
}

export { getWooClient, formatPrice, formatDateTime, getCountries, getStates, submitForm, decodeEntities, cn };
